<template>
  <div class="WidgetsViewHint">
    <div class="content">
      Wpisz poniżej adres swojej głównej strony internetowej (bez http:// i https://),
      na której chcesz umieścić kod z widgetem. System call web sprawdza tylko główny adres strony
      (bez adresów podstron). Oznacza to, że wystarczy wpisać adres mojastrona.pl i widget call web będzie
      widoczny na stronie głównej oraz na każdej podstronie, np. mojastrona.pl/kontakt.
    </div>
  </div>
</template>

<script>

export default {
  name: 'WebsitesViewHint',
};
</script>
